import { createBrowserRouter, redirect } from "react-router";
import { AuthGuard } from "./components/AuthGuard";
import { MainLayout } from "./layouts/MainLayout";
import { Login } from "./pages/Login";
import { Dashboard } from "./pages/Dashboard";
import { Catalogs } from "./pages/Catalogs";
import { Profiles } from "./pages/Profiles";
import { Mappings } from "./pages/Mappings";
import { ComponentLibrary } from "./pages/ComponentLibrary";
import { SSPEditor } from "./pages/SSPEditor";
import { AssessmentPlans } from "./pages/AssessmentPlans";
import { AssessmentPlanDetail } from "./pages/AssessmentPlanDetail";
import { AssessmentPlanWizard } from "./pages/AssessmentPlanWizard";
import { AssessmentResults } from "./pages/AssessmentResults";
import { AssessmentResultDetail } from "./pages/AssessmentResultDetail";
import { AssessmentExecutionList } from "./pages/AssessmentExecutionList";
import { AssessmentExecution } from "./pages/AssessmentExecution";
import { AssessmentReviewList } from "./pages/AssessmentReviewList";
import { AssessmentReview } from "./pages/AssessmentReview";
import { POAM } from "./pages/POAM";
import { POAMDetail } from "./pages/POAMDetail";
import { POAMItemDetail } from "./pages/POAMItemDetail";
import { Telemetry } from "./pages/Telemetry";
import { Governance } from "./pages/Governance";
import { AuditLogs } from "./pages/AuditLogs";
import { Users } from "./pages/Users";
import { Settings } from "./pages/Settings";
import { LicenseManagement } from "./pages/LicenseManagement";
import { ContentRegistry } from "./pages/ContentRegistry";
import { ComponentDefinitionVisualizer } from "./pages/visualizer/ComponentDefinitionVisualizer";
import { DirectoryConfiguration } from "./pages/DirectoryConfiguration";
import { OrganizationManagement } from "./pages/OrganizationManagement";
import { RoleManagement } from "./pages/RoleManagement";
import { UserManagement } from "./pages/UserManagement";
import { CISODashboard } from "./pages/CISODashboard";
// import { GRCDashboard } from "./pages/GRCDashboard"; // replaced by GRCDashboardNew
// import { GRCDashboardNew } from "./pages/GRCDashboardNew"; // now the per-org drill-down inside GRCManagerDashboard
import { GRCManagerDashboard } from "./pages/GRCManagerDashboard/GRCManagerDashboard";
import { DashboardRouter } from "./pages/DashboardRouter";
import { QuadrantDashboard } from "./pages/QuadrantDashboard";
import { ExecutiveInsights } from "./pages/ExecutiveInsights";
import { ReportsList } from "./pages/ReportsList";
import { ReportDetails } from "./pages/ReportDetails";
import { CMDBApplications } from "./pages/CMDBApplications";
import { CMDBApplicationDetail } from "./pages/CMDBApplicationDetail";
import { CMDBApplicationAssetDetail } from "./pages/CMDBApplicationAssetDetail";
import { CMDBAssets } from "./pages/CMDBAssets";
import { CMDBConfigItems } from "./pages/CMDBConfigItems";
import { CMDBServices } from "./pages/CMDBServices";
import { CMDBServiceDetail } from "./pages/CMDBServiceDetail";
import { CMDBCloudAccounts } from "./pages/CMDBCloudAccounts";
import { CMDBCloudAccountDetail } from "./pages/CMDBCloudAccountDetail";
import { CMDBDeviceDetail } from "./pages/CMDBDeviceDetail";
import { LlmConfigurations } from "./pages/LlmConfigurations";
import { ValidationRules } from "./pages/ValidationRules";
import { DashboardConfig } from "./pages/DashboardConfig/DashboardConfig";
import { DriftAnalysisWorkspace } from "./pages/grc/DriftAnalysisWorkspace";
import { ArchitectureCompliance } from "./pages/ArchitectureCompliance";

export const router = createBrowserRouter([
  {
    path: "/login",
    Component: Login,
  },
  {
    path: "/",
    Component: AuthGuard,
    children: [
      {
        Component: MainLayout,
        children: [
          { index: true, loader: () => redirect("/dashboard/Insights") },
          {  path: "dashboard", Component: DashboardRouter },
      { path: "dashboard/platform-owner", Component: Dashboard },
          { path: "dashboard/ciso", Component: CISODashboard },
          { path: "dashboard/grc-manager", Component: GRCManagerDashboard },
          { path: "dashboard/quadrant", Component: QuadrantDashboard },
          { path: "dashboard/Insights", Component: ExecutiveInsights },
          { path: "catalogs", Component: Catalogs },
          { path: "catalogs/:id", Component: Catalogs },
          { path: "profiles", Component: Profiles },
          { path: "profiles/:id", Component: Profiles },
          { path: "mappings", Component: Mappings },
          { path: "mappings/:id", Component: Mappings },
          { path: "components", Component: ComponentLibrary },
          { path: "components/:id", Component: ComponentLibrary },
          { path: "ssp", Component: SSPEditor },
          { path: "ssp/:id", Component: SSPEditor },
          { path: "assessment-plans", Component: AssessmentPlans },
          { path: "assessment-plans/wizard", Component: AssessmentPlanWizard },
          { path: "assessment-plans/:id", Component: AssessmentPlanDetail },
          { path: "assessment-execution", Component: AssessmentExecutionList },
          { path: "assessment-execution/:id", Component: AssessmentExecution },
          { path: "assessment-review", Component: AssessmentReviewList },
          { path: "assessment-review/:id", Component: AssessmentReview },
          { path: "assessment-results", Component: AssessmentResults },
          { path: "assessment-results/:id", Component: AssessmentResultDetail },
          { path: "drift-dashboard", Component: DriftAnalysisWorkspace },
          { path: "reports", Component: ReportsList },
          { path: "reports/:sspId", Component: ReportDetails },
          { path: "poam", Component: POAM },
          { path: "poam/:id", Component: POAMDetail },
          { path: "poam/:id/item/:itemId", Component: POAMItemDetail },
          { path: "telemetry", Component: Telemetry },
          { path: "content-registry", Component: ContentRegistry },
          { path: "content-registry/:id", Component: ContentRegistry },
          { path: "governance", Component: Governance },
          { path: "admin/audit-logs", Component: AuditLogs },
          { path: "users", Component: Users },
          { path: "settings", Component: Settings },
          { path: "admin/license-management", Component: LicenseManagement },
          { path: "visualizer", Component: ComponentDefinitionVisualizer },
          { path: "cmdb/applications", Component: CMDBApplications },
          { path: "cmdb/applications/:id", Component: CMDBApplicationDetail },
          {
            path: "cmdb/applications/:applicationId/assets/:assetId",
            Component: CMDBApplicationAssetDetail,
          },
          { path: "cmdb/assets", Component: CMDBAssets },
          { path: "cmdb/config-items", Component: CMDBConfigItems },
          { path: "cmdb/config-items/:id", Component: CMDBDeviceDetail },
          { path: "cmdb/services", Component: CMDBServices },
          { path: "cmdb/services/:id", Component: CMDBServiceDetail },
          { path: "cmdb/cloud-accounts", Component: CMDBCloudAccounts },
          {
            path: "cmdb/cloud-accounts/:id",
            Component: CMDBCloudAccountDetail,
          },
          { path: "admin/directory-config", Component: DirectoryConfiguration },
          { path: "admin/organizations", Component: OrganizationManagement },
          { path: "admin/roles", Component: RoleManagement },
          { path: "admin/users", Component: UserManagement },
          { path: "admin/llm-configurations", Component: LlmConfigurations },
          { path: "admin/validation-rules", Component: ValidationRules },

                { path: "admin/dashboard-config", Component: DashboardConfig },
                { path: "architecture-compliance", Component: ArchitectureCompliance },
        ],
      },
    ],
  },
  {
    path: "*",
    loader: () => redirect("/login"),
  },
]);
